exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#calculator .extraPaymentsButton {\n  padding: 3px 15px !important;\n}\na.extraPaymentsButton.closed::after {\n  border-width: 7px 7px 0 7px !important;\n}\na.extraPaymentsButton.open::after {\n  border-width: 0 7px 7px 7px !important;\n}\n", ""]);

// exports
